import warehouse from ".";

const state = {
    warehouse: [],
    warehouseId: [], 
    loading: false
};

export default state;